import React from 'react';
import './Loader.css'
const Loader = () => {
  return (
<div className="custom-loader"></div>
  );
};

export default Loader;